import { ECreateNftType } from 'constants/account/create-nft-types';
import { EPaymentStatus } from 'constants/account/payment-method';

export enum EAccountRouteKeys {
  ACCOUNT = '/account',
  ACCOUNT_LOGIN = '/account/login',
  ACCOUNT_REGISTER = '/account/register',
  ACCOUNT_REGISTER_COMPLETE = '/account/register-complete',
  ACCOUNT_RESET_PASSWORD = '/account/reset-password',
  ACCOUNT_FORGOT_PASSWORD = '/account/forgot-password',
  ACCOUNT_VERIFY_EMAIL = '/account/verify-email',
  ACCOUNT_AUTH = '/account/auth',
  ACCOUNT_PROFILE = '/account/profile',
  ACCOUNT_PROFILE_INFO = '/account/profile/info',
  ACCOUNT_PROFILE_WALLET_CALLBACK = '/account/profile/wallet/callback',
  ACCOUNT_PROFILE_MY_NFTS = '/account/profile/my-nfts',
  ACCOUNT_PROFILE_MY_NFTS_NFTS = '/account/profile/my-nfts/nft',
  ACCOUNT_PROFILE_MY_NFTS_OWNED = '/account/profile/my-nfts/owned',
  ACCOUNT_PROFILE_MY_NFTS_COLLECTION = '/account/profile/my-nfts/collection',
  ACCOUNT_PROFILE_CREATE_NFT = '/account/profile/create-nft',
  ACCOUNT_PROFILE_EDIT_NFT = '/account/profile/edit-nft',
  ACCOUNT_PROFILE_TRANSACTIONS = '/account/profile/transactions',
  ACCOUNT_PROFILE_BECOME_CREATOR = '/account/profile/become-creator',
  ACCOUNT_PROFILE_MERCHANDISE = '/account/profile/merchandise',
  ACCOUNT_PROFILE_MY_PAYMENTS = '/account/profile/my-payments',
  ACCOUNT_PROFILE_MENU = '/account/profile/menu',
  ACCOUNT_CHECKOUT = '/nft-checkout'
}

export const AccountQueryKey = {
  modal: {
    value: 'modal',
    option: {
      CHOOSE_CREATE_NFT: 'choose-create-nft',
      LIST_NFT: 'list-nft',
      BECOME_CREATOR: 'become-creator',
      MINT_SUCCESS_NFT: 'mint-success-nft',
      MINT_FAIL_NFT: 'mint-fail-nft',
      CHOOSE_PRINT_NFT: 'choose-print-nft',
      PRINT_NFT: 'print-nft',
      IMPORT_NFTS: 'import-nfts'
    }
  },
  type: {
    value: 'type',
    option: {
      [ECreateNftType.REGULAR]: '0',
      [ECreateNftType.UTILITY]: '1',
      [ECreateNftType.IMPORT]: '2'
    }
  },
  nftId: {
    value: 'nftId'
  },
  paymentStatus: {
    value: 'paymentStatus',
    option: {
      [EPaymentStatus.FAILED]: EPaymentStatus.FAILED,
      [EPaymentStatus.SUCCESS]: EPaymentStatus.SUCCESS
    }
  },
  merchandiseProduct: {
    value: 'merchandiseProduct'
  },
  checkout: {
    value: 'token'
  }
};
